/* eslint-disable max-len */
import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-toolbox/lib/button';
import Card from 'components/Card';
import { DropdownDiv, ContainerDiv } from './styledComponents';
import isIfiPhase from '../../../components/ifiUtils';
import S from '../styles.scss';

const ScriptsIntro = (props) => {
  const { user, phase, title, customerAnswered, handleBasicQuestion } = props;
  const isFollowUpDelivery = type => type === 'Follow Up Delivery Call';
  const isFollowUp = type => type === 'Follow Up Call';
  const important = text => <span className={S.scriptText}>{text}</span>;
  return (<Card className={S.card}>
    <div className={S.headerContainer}>
      <h4 className={S.title}>{title} Script Intro</h4>
    </div>
    <div className={S.scriptContainer}>
      <p className={S.scriptUserNote}>USER NOTE: Did the customer answer?</p>
      <br />
      <Button
        label="ANSWERED"
        flat inverse ripple
        disabled={customerAnswered === 'yes'}
        className={S.standardButton}
        onClick={() => handleBasicQuestion('customerAnswered', 'yes')}
      />
      <Button
        label="VOICEMAIL"
        flat inverse ripple
        disabled={customerAnswered === 'no'}
        className={S.standardButton}
        onClick={() => handleBasicQuestion('customerAnswered', 'no')}
      />
    </div>
    {customerAnswered && <ContainerDiv>
      <DropdownDiv condition={customerAnswered}>
        <div className={S.scriptContainer}>
          {isFollowUpDelivery(title) ? (<p>
            Hello Mr./Ms. {important(phase.customer_name)},
            this is {important(user)} with {isIfiPhase(phase) ? "Integrity First Installations, your Lowe's millwork specialist" : 'Service Pros'}. I wanted to touch
            base to ensure that everything went okay with the delivery of
            your materials.
          </p>) : (<p>
            Hi, Mr./Ms. {important(phase.customer_name)},
            my name is {important(user)} with {isIfiPhase(phase) ? "Integrity First Installations, your Lowe's millwork specialist" : 'Service Pros'}, calling
            {isFollowUp(title) ? ' to follow up on ' : ' about '}
            your {important(phase.surface_type.name)} installation
            {isFollowUp(title) ? ' and make sure everything went well' : ''}.
          </p>)}
        </div>
      </DropdownDiv>
    </ContainerDiv>}
    {customerAnswered === 'yes' && <ContainerDiv>
      <DropdownDiv condition={customerAnswered === 'yes'}>
        <div className={S.scriptContainer}>
          <p className={S.scriptUserNote}>USER NOTE: Pause and allow the customer to respond.</p>
        </div>
      </DropdownDiv>
    </ContainerDiv>}
  </Card>);
};

ScriptsIntro.propTypes = {
  user: PropTypes.string,
  phase: PropTypes.object,
  title: PropTypes.string,
  customerAnswered: PropTypes.string,
  canTalk: PropTypes.string,
  handleBasicQuestion: PropTypes.func,
};

export default ScriptsIntro;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseCommunications/components/scriptsIntro.jsx